import { render } from "./buttonAjax.vue?vue&type=template&id=6862ca30"
import script from "./buttonAjax.vue?vue&type=script&lang=js"
export * from "./buttonAjax.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__